<template>
  <header>
    <div class="top-bar bg-color">
    </div>
    <div class="nav-box">
      <div id="boxFixed" :class="['nav-box-outer', isFixed ? 'fix' : '']">
        <div class="container">
          <div class="col-lg-2 col-md-2 col-xs-7 col-my-9">
            <div class="logo">
              <router-link to="/">
                <img width="142" height="50"
                  :src="changeRed == 0 ? require('../img/klm_en.png') : require('../img/klm_cn.png')"
                  alt="KAM LUNG MOTOR GROUP" />
              </router-link>
            </div>
          </div>
          <div class="col-lg-10 col-md-10 col-xs-5 col-my-3 nav-box-title">
            <button type="button" class="navbar-toggle" :class="collapsed ? '' : 'collapsed'"
              @click="collapsed = !collapsed">
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar top-bar"></span>
              <span class="icon-bar middle-bar"></span>
              <span class="icon-bar bottom-bar"></span>
            </button>
            <el-collapse-transition>
              <nav v-show="screenWidth > 980 ? true : collapsed" :style="{ top: isFixed ? '60px' : '60px' }">
                <ul>
                  <li :class="changeRed == 0 ? 'en' : ''" v-for="(nav, index) in navList" :key="index"
                    @click="changeCollapsed()">
                    <router-link :to="nav.url" :class="{ active: nav.url === $route.path }">{{ nav.title
                    }}</router-link>
                  </li>
                  <li v-show="screenWidth < 980">
                    <div :class="['langCol', isFixed ? 'fix' : '']">
                      <div :class="['li-lang', list.class, list.txt != $t('language.name') ? 'active' : '']"
                        v-for="(list, index) in languageList" :key="index" @click="changeLanguage(list.to, index)">
                        {{ list.txt }}</div>
                    </div>
                  </li>
                </ul>
              </nav>
            </el-collapse-transition>
            <div v-show="screenWidth > 980" :class="['langCol', isFixed ? 'fix' : '']">
              <div :class="['li-lang', list.class, list.txt != $t('language.name') ? 'active' : '']"
                v-for="(list, index) in languageList" :key="index" @click="changeLanguage(list.to, index)">
                {{ list.txt }}</div>
            </div>
          </div>
          <!-- <div class="col-md-2 col-xs-3 col-my-3">
          </div> -->
        </div>
      </div>
    </div>
    <!-- <div class="mp-8 bg-color"></div> -->
  </header>
</template>

<script>
import Swiper from "swiper"
import PubSub from 'pubsub-js'
export default {
  name: "Header",
  inject: ['reload'],
  data() {
    return {
      collapsed: false,
      screenWidth: document.body.clientWidth,
      isFixed: false,
      navList: [
        // {url: '/', title: 'Home'},
        // {url: '/valueyourcar', title: 'Value Your Car'},
        // {url: '/contactus', title: 'Contact Us'},
      ],

      show: false,
      changeRed: 0,
      languageList: [
        { id: 0, to: 'en', class: '', txt: 'ENG' },
        { id: 1, to: 'zh', class: 'langTc', txt: '中文' },
      ],
    }
  },
  mounted() {
    let that = this
    that.navLists()

    if (that.$t('language.name') != '中文') {
      that.changeRed = 1
    } else {
      that.changeRed = 0
    }

    window.addEventListener('scroll', that.handleScroll)

    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    // console.log('w', that.screenWidth)

    that.getscreenWidth()
    document.body.style.cssText = '';
  },
  beforeDestroy() {
    // 组件销毁时移除事件监听，避免内存泄漏
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    changeCollapsed() {
      this.collapsed = false
    },
    //替换中英文
    navLists() {
      let that = this
      that.navList = that.$t('navList')

    },
    handleScroll() {
      requestAnimationFrame(() => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
        let offsetTop = document.querySelector('#boxFixed').scrollHeight  // 要滚动到顶部吸附的元素的偏移量
        this.isFixed = scrollTop > offsetTop ? true : false  // 如果滚动到顶部了，this.isFixed就为true
        // console.log('scrollTop', scrollTop)
        // console.log('offsetTop', offsetTop)
      })
    },
    changeLanguage(to, index) {
      this.$i18n.locale = to
      this.changeRed = index

      // this.$i18n.locale=='zh'?this.$i18n.locale='en':this.$i18n.locale='zh'   //设置中英文模式
      localStorage.setItem('languageSet', this.$i18n.locale)   //将用户设置存储到localStorage以便用户下次打开时使用此设置
      this.$store.commit('$_setLocale', this.$i18n.locale)

      // 发布消息
      PubSub.publish('locale', { locale: this.$i18n.locale })

      this.navLists()

      this.show = false
    },
    // 浏览器窗口大小
    getscreenWidth() {
      // console.log('this.screenWidth', this.screenWidth)
      if (this.screenWidth >= 768) {
        this.show = false
      }
    }
  },
  watch: {
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val
        this.timer = true
        let that = this
        setTimeout(() => {
          that.getscreenWidth()
          that.timer = false
        }, 200)
      }
    },
    navList(val) {
      if (this.navList.length != 0) {
        // console.log('123', val)
        // 发布消息
        PubSub.publish('navs', this.navList)
      }
    }
  }
}
</script>

<style scoped lang="scss">
/* header */
header {
  position: relative;
  z-index: 100;
  .container {
    padding: 0;
  }
  a {
    cursor: pointer;
  }

  .langCol {
    position: relative;
    // padding: 28px 0 25px 64px;
    // padding: 19px 0 16px 58px;
    padding: 19px 0 16px 0;
    display: block;
    font-size: 18px;
    text-decoration: none;
    text-align: center;
    color: #4e5256;
    border-right: 1px solid rgba(255, 255, 255, 0.1);

    &.fix {
      // padding: 27px 20px 24px 66px;
      padding: 19px 27px 16px;
    }

    .li-lang {
      display: inline;
      font-weight: 600;
      font-size: 14px;
      text-decoration: none;
      padding-right: 9px;
      border-right: 1px solid #000;
      cursor: pointer;

      &.langTc {
        padding-left: 9px;
        padding-right: 0px;
        font-size: 14px;
        border-right: none;
      }

      &.active {
        text-decoration: underline;
      }
    }
  }

  .nav-box {
    background: #fff;
    // background: url('../picture/bg.jpg') repeat center top fixed;
    height: 60px;
    .nav-box-title {
      display: flex;
      justify-content: space-around;
      .nav {
        display: flex;
        align-items: center;
      }
    }
    .nav-box-outer {
      position: relative;
      background-color: rgba(255, 255, 255, 0.95);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      z-index: 9999;

      &.fix {
        position: fixed;
        top: 0;
        width: 100%;

        .logo {
          line-height: 60px;
        }

        nav {
          ul {
            li {
              a {
                // padding: 27px 30px 24px;
                padding: 19px 23px 16px;
              }
            }
          }
        }
      }

      .logo {
        line-height: 60px;
        -webkit-transition: line-height 0.25s ease-in-out;
        -moz-transition: line-height 0.25s ease-in-out;
        -ms-transition: line-height 0.25s ease-in-out;
        -o-transition: line-height 0.25s ease-in-out;
        transition: line-height 0.25s ease-in-out;

        img {
          margin: 0;
          display: inline-block;
          max-width: 100%;
          width: 120px;
          height: auto;
          vertical-align: middle;
          -webkit-transition: max-height 0.25s ease-in-out;
          -moz-transition: max-height 0.25s ease-in-out;
          -ms-transition: max-height 0.25s ease-in-out;
          -o-transition: max-height 0.25s ease-in-out;
          transition: max-height 0.25s ease-in-out;
          -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
        }
      }

      nav {
        float: right;
        padding: 0;

        ul {
          li {
            position: relative;
            float: left;
            margin: 0;
            list-style: none;

            a {
              position: relative;
              padding: 19px 27px 16px;
              display: block;
              font-family: 'AttenNewRegular', 'Source Han Serif SC';
              font-size: 18px;
              font-weight: 400;
              text-decoration: none;
              text-align: center;
              color: #4e5256;
              border-right: 1px solid rgba(255, 255, 255, 0.1);

              &.is-active, &[aria-current='page'] {
                background: #ae0526;
                color: #fff;

                &:hover {
                  background: #ae0526;
                  color: #fff;
                }
              }

              &:hover {
                background: #ae0526;
                color: #4e5256;
                background-color: rgba(0, 0, 0, 0.1);
                -webkit-transition: color 0.25s ease-in-out;
                -moz-transition: color 0.25s ease-in-out;
                -ms-transition: color 0.25s ease-in-out;
                -o-transition: color 0.25s ease-in-out;
                transition: color 0.25s ease-in-out;
              }
            }

            &::after {
              position: absolute;
              left: 100%;
              top: 50%;
              content: '';
              height: 20px;
              border-right: 1px solid rgba(0, 0, 0, 0.15);
              -webkit-transform: translate(-100%, -50%);
              -ms-transform: translate(-100%, -50%);
              transform: translate(-100%, -50%);
            }

            &:last-of-type, &:nth-last-of-type(2) {
              &::after {
                display: none;
              }
            }
          }
        }
      }
    }
  }
  
  @media (max-width: 1440px) {
    .nav-box .nav-box-outer nav ul li a {
      // padding: 19px 24px 16px !important;
      padding: 19px 25px 16px !important;
    }
  }

  @media (max-width: 1200px) {
    .langCol {
      // padding: 19px 0 16px 32px !important;
      // padding: 19px 0 16px 18px !important;
    }

    .nav-box .nav-box-outer nav ul li a {
      // padding: 19px 24px 16px !important;
      // padding: 19px 21px 16px !important;
      padding: 19px 15px 16px !important;
      font-size: 17px;
    }

    .nav-box .nav-box-outer nav ul li.en a {
      padding: 19px 16px 16px !important;
    }
  }

  @media (max-width: 996px) {
    button {
      margin-top: 6px;
      margin-bottom: 0;
      margin-right: 0;
      padding: 9px 3px;
      border: none;
      background: transparent !important;
      position: relative;
      float: right;
      border-radius: 0px;
      cursor: pointer;
    }

    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
    }

    .icon-bar {
      -webkit-transition: all 0.2s;
      -o-transition: all 0.2s;
      transition: all 0.2s;
      display: block;
      // width: 22px;
      // height: 2px;
      border-radius: 1px;
      background-color: #333;
    }

    .navbar-toggle:hover {
      background: transparent !important;
    }

    .navbar-toggle .icon-bar {
      margin-top: 5px;
      width: 27px;
      height: 4px;
      -webkit-transition: all 0.2s;
      -o-transition: all 0.2s;
      transition: all 0.2s;
    }

    .navbar-toggle .top-bar {
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      -o-transform: rotate(45deg);
      transform: rotate(45deg);
      -webkit-transform-origin: 10% 10%;
      -moz-transform-origin: 10% 10%;
      -ms-transform-origin: 10% 10%;
      transform-origin: 10% 10%;
    }

    .navbar-toggle .middle-bar {
      opacity: 0;
    }

    .navbar-toggle .bottom-bar {
      -webkit-transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      -o-transform: rotate(-45deg);
      transform: rotate(-45deg);
      -webkit-transform-origin: 10% 90%;
      -moz-transform-origin: 10% 90%;
      -ms-transform-origin: 10% 90%;
      transform-origin: 10% 90%;
    }

    .navbar-toggle.collapsed .top-bar {
      -webkit-transform: rotate(0);
      -ms-transform: rotate(0);
      -o-transform: rotate(0);
      transform: rotate(0);
    }

    .navbar-toggle.collapsed .middle-bar {
      opacity: 1;
    }

    .navbar-toggle.collapsed .bottom-bar {
      -webkit-transform: rotate(0);
      -ms-transform: rotate(0);
      -o-transform: rotate(0);
      transform: rotate(0);
    }
    
    .nav-box .nav-box-title {
      justify-content: flex-end;
    }
    
    nav {
      position: fixed;
      top: 118px;
      left: 0;
      width: 100%;
      background: #fff;
      -webkit-box-shadow: 0 1px 4px #999;
      box-shadow: 0 1px 4px #999;

      ul {
        width: 100%;

        li {
          width: 100%;

          a {
            padding: 20px 20px 20px !important;
            background-color: transparent;
            color: #000;
            border-bottom: 1px solid #ccc;
          }

          &:last-of-type {
            .langCol {
              padding: 20px 20px 20px !important;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue